import CategoryListTable from './categoryListTable.container';

export default CategoryListTable